import React, {Component} from 'react';
import {connect} from 'react-redux';
import { Field, reduxForm } from 'redux-form';

import Form from 'common/components/Form';
import Button from 'common/components/Button/Button';
import Input from 'common/components/Input/Input';

import './ActionForm.less';

import validate from './validate';

class ActionForm extends Component {

    render() {

        const {
            email,
            onSubmit,
            loginPending
        } = this.props;

        return (
            <Form className="LoginContainer-form"
                  form="activate"
                  validate={validate}
                  onSubmit={onSubmit}>

                <div className="LoginContainer-message">
                    Create new password for {email}
                </div>

                <Field component={Input}
                       label="Password"
                       name="password"
                       inputType="password"
                       grow={true} />

                <Field component={Input}
                       label="Confirm password"
                       name="password2"
                       inputType="password"
                       grow={true} />

                <div className="LoginContainer-button">
                    <Button type="solid"
                            color="primary"
                            disabled={loginPending}
                            grow={true}>
                        Submit
                    </Button>
                </div>
            </Form>
        );
    }
}

export default ActionForm;



// WEBPACK FOOTER //
// ./assets/app/login/components/ActionForm/ActionForm.jsx